const model = {
    partnerDetails: null,
    loading: false,
    error: null,
};

export default model;